module.exports = __webpack_public_path__ + "img/whatsnew-scribble_en.1ec1ab7.jpg";